import { render, staticRenderFns } from "./BrandProgress.vue?vue&type=template&id=e1049d5e&scoped=true&"
import script from "./BrandProgress.vue?vue&type=script&lang=js&"
export * from "./BrandProgress.vue?vue&type=script&lang=js&"
import style0 from "./BrandProgress.vue?vue&type=style&index=0&id=e1049d5e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1049d5e",
  null
  
)

export default component.exports